import styled from 'styled-components'
import { breakpoints } from '@assets/global-style/global-style'

const BoxReCaptcha = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.sm}) {
    margin-bottom: 25px;
  }
`

export { BoxReCaptcha }
